import React, {useEffect, useState} from 'react';
import SupportBox from "./SupportBox";
import SupportModal from "./SupportModal";
import SupportViewModal from "./SupportViewModal";
import axios from "axios";
import {API_PATH} from "../../components/const";

const Support = () => {
    const [addModal, setAddModal] = useState(false)
    const [viewModal, setViewModal] = useState(false)
    const [pic, setPic] = useState(null);
    const [text, setText] = useState("");
    const [selectItem, setSelectItem] = useState({});
    const [application, setApplication] = useState([]);
    const [inProgress, setInProgress] = useState([]);
    const [inTest, setInTest] = useState([]);
    const [done, setDone] = useState([]);
    const [type, setType] = useState(null);


    const getDataApp = () => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/ticket/status/application", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setApplication(res?.data?.items)
            })
    }
    const getDataInProgress = () => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/ticket/status/in_progress", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setInProgress(res?.data?.items)
            })
    }
    const getDataInTest = () => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/ticket/status/in_test", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setInTest(res?.data?.items)
            })
    }
    const getDataDone = () => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/ticket/status/done", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setDone(res?.data?.items)
            })
    }
    const getItem = (id) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/ticket/" + id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setSelectItem(res?.data)
            })
    }
    const createApplication = () => {
        let bigData = new FormData()
        if (pic?.target?.files[0]) {
            bigData.append("image", pic?.target?.files[0])
        }
        bigData.append("title", text)
        bigData.append("status", "application")
        axios.post(API_PATH + "company/" + localStorage.getItem('id') + "/ticket/", bigData, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                getDataApp()
                setAddModal(false)
                setText("")
                setPic(null)
            })
    }
    useEffect(() => {
        getDataApp()
        getDataInProgress()
        getDataInTest()
        getDataDone()
    }, []);
    return (
        <div className="support">
            <h3 className="cam-title">
                Support
            </h3>
            <div className="support-big-box">
                <div className="support-list">
                    <div className="list-item">
                        <div className="list-header-1 list-header">
                            <h3>Application</h3>
                        </div>
                        <div className="list-content">
                            {
                                application?.map((item, index) => (
                                    <SupportBox
                                        key={index}
                                        setViewModal={setViewModal}
                                        viewModal={viewModal}
                                        data={item}
                                        getItem={getItem}
                                        setType={setType}
                                    />
                                ))
                            }

                        </div>
                        <div className="create-ticket">
                            <button onClick={() => setAddModal(true)}>
                                <img src="/icon/plus.svg" alt="+"/> Create an application
                            </button>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="list-header-2 list-header">
                            <h3>In Progress</h3>
                        </div>
                        <div className="list-content list-content-bottom">
                            {
                                inProgress?.map((item, index) => (
                                    <SupportBox
                                        key={index}
                                        setViewModal={setViewModal}
                                        viewModal={viewModal}
                                        data={item}
                                        getItem={getItem}
                                        setType={setType}
                                    />
                                ))
                            }

                        </div>
                    </div>
                    <div className="list-item">
                        <div className="list-header-3 list-header">
                            <h3>In Test</h3>

                        </div>
                        <div className="list-content list-content-bottom">
                            {
                                inTest?.map((item, index) => (
                                    <SupportBox
                                        key={index}
                                        setViewModal={setViewModal}
                                        viewModal={viewModal}
                                        data={item}
                                        getItem={getItem}
                                        setType={setType}
                                    />
                                ))
                            }

                        </div>
                    </div>
                    <div className="list-item">
                        <div className="list-header-4 list-header">
                            <h3>Done</h3>

                        </div>
                        <div className="list-content list-content-bottom">
                            {
                                done?.map((item, index) => (
                                    <SupportBox
                                        key={index}
                                        setViewModal={setViewModal}
                                        viewModal={viewModal}
                                        data={item}
                                        getItem={getItem}
                                        setType={setType}
                                    />
                                ))
                            }

                        </div>
                    </div>
                </div>
            </div>
            {
                addModal
                    ?
                    <SupportModal
                        isModalOffice={addModal}
                        setIsModalOffice={setAddModal}
                        setText={setText}
                        text={text}
                        setPic={setPic}
                        pic={pic}
                        createApplication={createApplication}
                        getDataApp={getDataApp}
                    />
                    :
                    ""
            }

            {
                viewModal
                    ?
                    <SupportViewModal
                        getDataInProgress={getDataInProgress}
                        getDataInTest={getDataInTest}
                        getDataDone={getDataDone}
                        getDataApp={getDataApp}
                        isModalOffice={viewModal}
                        setIsModalOffice={setViewModal}
                        selectItem={selectItem}
                        setSelectItem={setSelectItem}
                        type={type}
                    />
                    :
                    ""
            }

        </div>
    );
};

export default Support;